import Style from "./EnterprisesUpdatesTableStyle";
import Spinner from "../../shared/Spinner/Spinner";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import api from "../../services/api";

import { FaTrashAlt } from "react-icons/fa";
import { useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle";

export default function EnterprisesUpdatesList(props) {

  const [updates, setUpdates] = useState([] as any);
  const [deletingUpdate, setDeletingUpdate] = useState(false);
  const [updateToDelete, setUpdateToDelete] = useState({} as any);
  const [message, setMessage] = useState({ success: "", error: "" });
  const [loading, setLoading] = useState(false);
  const enterpriseId = props.match.params.enterpriseId;

  useEffect(() => {
    LoadUpdates();
  }, []);


  function CreateUpdate() {
    GoToUpdateDetails(-1);
  }

  function GoToUpdateDetails(updateId) {
    props.history.push(`/enterprises/${enterpriseId}/updates/${updateId}`);
  }

  async function DeleteUpdate() {
    setDeletingUpdate(true);
    setLoading(true);
    try {
      const result = await api.delete(`/enterprises/${enterpriseId}/updates/${updateToDelete.id}`);
      if (result.data.success) {
        setMessage({ success: "Atualização de obra deletada com sucesso!", error: "" });
        setLoading(false);
      } else {
        setMessage({ success: "", error: "Problema ao deletar a atualização da obra!" });
        setLoading(false);
      }
      await LoadUpdates();
      setDeletingUpdate(false);
      ClosePopupDeletingUpdate();
    }
    catch (error) {
      setDeletingUpdate(false);
      ClosePopupDeletingUpdate();
      setLoading(false);
      setMessage({ success: "", error: "Problema ao deletar a atualização da obra!" });
    }

  }

  async function LoadUpdates() {
    setLoading(true);
    try {
      const result = await api.get(`/enterprises/${enterpriseId}/updates`);
      if (!result.data.success) {
        setMessage({ success: "", error: "Não foi possível carregar atualizações da obra!" })
        setLoading(false);
        return;
      }
      setUpdates(result.data.updates);
      setLoading(false);
    }
    catch (error) {
      setLoading(false);
      setMessage({ success: "", error: "Houve um erro ao carregar atualizações!" })
    }
  }

  function ClosePopupDeletingUpdate() {
    setUpdateToDelete({});
  }
  return (
    <Style>
      <PageTitle title="Atualizações da Obra" />
      <TwoButtonsModal
        show={updateToDelete.id != null}
        onHide={ClosePopupDeletingUpdate}
        loading={deletingUpdate}
        title="Deleção de atualização!"
        body={`Você está tentando deletar a atualização "${updateToDelete.name}", essa ação é irreversível!`}
        secondaryText="Fechar"
        secondaryOnClick={ClosePopupDeletingUpdate}
        secondaryDisabled={deletingUpdate}
        primaryText="Deletar"
        primaryOnClick={DeleteUpdate}
        primaryDisabled={deletingUpdate}
      />
      <button onClick={() => props.history.goBack()} className=" btn-secondary">Voltar</button>
      <Spinner spinning={loading} />
      <section className="table-title">
        <h1>Atualizações da Obra</h1>
        <button onClick={CreateUpdate}>Adicionar Atualização</button>
      </section>
      {message.error && <p className="alert alert-error">Erro: {message.error}</p>}
      {message.success && <p className="alert alert-info">{message.success}</p>}

      <table className="table table-striped table-bordered table-hover main-table">
        <thead >
          <tr>
            <th>Atualização</th>
            <th>Fotos</th>
            <th>Ações</th>
          </tr>
        </thead>

        <tbody>
          {updates.length > 0 && updates.map(update => {
            return (
              <tr key={update.id}>
                <td className="clickable" onClick={() => GoToUpdateDetails(update.id)}>{update.name}</td>
                <td className="clickable" onClick={() => GoToUpdateDetails(update.id)}>{update.photos.length}</td>
                <td>
                  <div className="action" onClick={() => setUpdateToDelete(update)}
                  ><FaTrashAlt className="icon" /></div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Style>

  )
}